import { rtdb } from "../firebase";
import { ref, push } from "firebase/database";

/**
 * Save download history to Firebase Realtime Database
 * @param {string} creatorName - Name of the person who downloaded
 * @param {string} patentId - Patent ID
 * @param {string} formName - Name of the form (e.g., "FORM1.docx")
 * @param {string} [trackingNumber] - Optional tracking number entered by user
 */
export async function saveDownloadHistory(creatorName, patentId, formName, trackingNumber, applicantName) {
  try {
    const historyRef = ref(rtdb, "/downloadHistory");
    await push(historyRef, {
      creatorName: creatorName || "Unknown",
      patentId: patentId || "N/A",
      formName: formName,
      trackingNumber: trackingNumber || null,
      applicantName: applicantName || null,
      timestamp: Date.now(),
    });
  } catch (error) {
    console.error("Error saving download history:", error);
    throw error;
  }
}
